const theme = {
  mediaLg: "@media (min-width:1200px)",

  fontFamily: '"Quicksand", "Helvetica Neue", sans-serif',

  white: "#FFFFFF",
  silver: "#A1A1A1",
  silverRGB: "161, 161, 161",
  grey: "#585858",
  black: "#000000",
  blueRGB: "25, 118, 210",
};

export default theme;
